import { apiClient } from "../api";

/**
 * Servicio de noticias y eventos.
 * API: http://localhost:8080/noticias-eventos
 */

/**
 * Obtiene la lista de noticias y eventos.
 */
export const getNoticiasEventos = async () => {
  const { data } = await apiClient.get("noticias-eventos");
  return data;
};

/**
 * Obtiene una noticia/evento por ID.
 */
export const getNoticiaEvento = async (id) => {
  const { data } = await apiClient.get(`noticias-eventos/${id}`);
  return data;
};

/**
 * Crea una nueva noticia o evento.
 */
export const createNoticiaEvento = async (payload) => {
  const { data } = await apiClient.post("noticias-eventos", payload);
  return data;
};

/**
 * Actualiza una noticia/evento existente.
 */
export const updateNoticiaEvento = async (id, payload) => {
  const { data } = await apiClient.put(`noticias-eventos/${id}`, payload);
  return data;
};
